<template>
  <nav>
    <v-app-bar class="appbar" app clipped-left>
      <a class="logo-link" href="#/">
        <img src="../assets/epicflow.svg" alt="EpicFlow Logo" class="logo" />
      </a>
      <v-spacer />

      <v-btn class="btn" @click="routeTo('signup')">
        <span>Sign Up</span>
        <v-icon right>mdi-exit-to-app</v-icon>
      </v-btn>

      <v-btn class="btn" @click="routeTo('login')">
        <span>Login</span>
        <v-icon right>mdi-exit-to-app</v-icon>
      </v-btn>
<!-- 
      <v-btn class="btn" href="https://www.epicflow.com/">
        <span>Product</span>
        <v-icon right>mdi-exit-to-app</v-icon>
      </v-btn> -->
    </v-app-bar>

    <SideBar />
  </nav>
</template>

<script>
import SideBar from "@/components/SideBar";

export default {
  components: {
    SideBar,
  },
  mounted: function () {},
  methods: {
    routeTo(route) {
      if (route == this.$route.name.toLowerCase()) return;

      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.logo {
  height: 60%;
}

.btn {
  margin: 5px;
}
.link-container {
  display: block;
  align-items: center;
  position: relative;
  font-weight: 400;
  user-select: none;
  width: 100%;
}

.logo-link {
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
